var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","nudge-bottom":"8"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticClass:"dmb-form-text warning--text"},on),[_vm._t("default")],2)]}}],null,true)},[_c('span',{staticClass:"caption"},[_vm._v("Schubladentarif")])])}
var staticRenderFns = []

export { render, staticRenderFns }